import { DynamicVariableType, DynamicVariableValues } from '@nx-frontend/shared/types';

export function getDynamicVariableShortcut(type: DynamicVariableType): string {
  return `{{${type}}}`;
}

const dynamicVariableMapping: Record<DynamicVariableType, keyof DynamicVariableValues> = {
  [DynamicVariableType.CLIENT_NAME]: 'firstName',
  [DynamicVariableType.CLIENT_LAST_NAME]: 'lastName',
};

export function getTextWithPreparedVariables(text?: string, values?: DynamicVariableValues) {
  if (!text || !values) {
    return text;
  }
  const variablePattern = /\{\{(\w+)\}\}/g;

  return text.replace(variablePattern, (_, variableName) => {
    const variableKey = variableName as DynamicVariableType;

    const valueKey = dynamicVariableMapping[variableKey];
    const replacement = valueKey ? values[valueKey] : undefined;

    return replacement ?? `{{${variableName}}}`;
  });
}
